import { EnumSurveyType, getQuestionSurveyType } from "../components/Enums";
import star from "src/img/survey/icons/star.webp";
import bad from "src/img/survey/icons/bad.webp";
import poor from "src/img/survey/icons/poor.webp";
import ok from "src/img/survey/icons/ok.webp";
import great from "src/img/survey/icons/great.webp";
import excellent from "src/img/survey/icons/excellent.webp";
import yes from "src/img/survey/insight_yes.png";
import no from "src/img/survey/insight_no.png";
import yesSelected from "src/img/survey/insight_yes_selected.png";
import noSelected from "src/img/survey/insight_no_selected.png";
import { AppSurvey, QuestionType, SurveyAnswer, SurveyQuestion } from "./surveyApi";

export interface AnswerChoice {
    value: string;
    label: string;
    image: string;
    selectedImage?: string;
}

export const SURVEY_CHOICES: Record<QuestionType, AnswerChoice[]> = {
    Rating: Array.from({ length: 5 }, (_, index: number) => ({
        value: String(index + 1), label: `${index + 1} ${index === 0 ? "star" : "stars"}`, image: star
    })),
    Satisfaction: [
        { value: "bad", label: "Bad", image: bad },
        { value: "poor", label: "Poor", image: poor },
        { value: "ok", label: "OK", image: ok },
        { value: "great", label: "Great", image: great },
        { value: "excellent", label: "Excellent", image: excellent }
    ],
    "Yes/No": [
        { value: "Yes", label: "Yes", image: yes, selectedImage: yesSelected },
        { value: "No", label: "No", image: no, selectedImage: noSelected }
    ],
    Feedback: []
};

export function questionType(survey: AppSurvey, question: SurveyQuestion): QuestionType {
    return getQuestionSurveyType(survey, question) as QuestionType;
}

export function orderedQuestions(survey: AppSurvey): SurveyQuestion[] {
    return [...survey.surveyQuestions].sort((a, b) => a.questionOrder - b.questionOrder);
}

export function invalidQuestions(survey: AppSurvey, answers: Record<string, string>): SurveyQuestion[] {
    return orderedQuestions(survey).filter(question => {
        const type: QuestionType = questionType(survey, question);
        if (type === EnumSurveyType.FEEDBACK) {
            return !answers[question.uuid]?.trim();
        }
        return !SURVEY_CHOICES[type]?.some(choice => choice.value === answers[question.uuid]);
    });
}

export function serializeAnswers(survey: AppSurvey, answers: Record<string, string>): SurveyAnswer[] {
    return orderedQuestions(survey).map(question => ({
        surveyQuestionUuid: question.uuid,
        answerOrFeedbackResponse: (answers[question.uuid] ?? "").trim()
    }));
}
